/**
 * 06 · Case study — anonymised (customer has not yet approved use of their
 * name; do NOT name them until permission is given). Truth rules: Phase 1
 * (attribution) live, Phase 2 (CRM/bookings cutover) underway — never
 * "fully replaced". No Mailchimp / Calendly claims.
 */
export default function CaseStudy() {
  return (
    <section className="tint" id="case">
      <div className="wrap">
        <div className="sec-head">
          <div className="sec-num">05 · In production</div>
          <div>
            <h2>
              Five tools, <span className="ph">one runtime</span>.
            </h2>
            <p className="lede">
              A leading Australian clinic group (NSW + VIC) ran their growth engine across a
              CRM, a bookings platform, call-centre telephony, website lead forms and a
              broken ad stack. rcrt is consolidating all of it into one Growth &amp;
              Bookings Hub.
            </p>
          </div>
        </div>

        <div className="case-panel">
          <div className="case-grid">
            <div>
              <span className="case-kicker">The problem</span>
              <h3>$31k/month of paid search, 28 cents back per dollar.</h3>
              <p>
                23+ broken and duplicate conversion actions meant Google's bidding optimised
                to noise. No system could join an ad click to a booked consultation to
                revenue. Five disconnected tools each held a fragment of the answer.
              </p>
              <div style={{ marginTop: 26 }}>
                <div className="case-stat">
                  <div className="n">~$31k/mo</div>
                  <div className="l">paid search spend at ~0.28 ROAS before rcrt</div>
                </div>
                <div className="case-stat">
                  <div className="n">137k / 103k / 122k</div>
                  <div className="l">contacts, deals and calls scoped for migration off HubSpot</div>
                </div>
                <div className="case-stat">
                  <div className="n">23+ → 2</div>
                  <div className="l">broken conversion actions collapsed to two clean, revenue-valued ones</div>
                </div>
              </div>
            </div>
            <div>
              <span className="case-kicker">The build</span>
              <h3>A Growth &amp; Bookings Hub with an advisor that acts.</h3>
              <p>
                Leads, bookings, campaigns, attribution and customers — all breadcrumbs on one
                runtime. A growth-advisor agent generates ad creative, reallocates budget,
                applies negative keywords, exports conversions, creates bookings and advances
                deals. Every action human-approved.
              </p>
              <div className="stack-list">
                <span className="stack-pill gone">HubSpot CRM</span>
                <span className="stack-pill gone">Bookings + POS platform</span>
                <span className="stack-pill gone">Call-centre telephony</span>
                <span className="stack-pill gone">WordPress lead forms</span>
                <span className="stack-pill gone">Broken ads conversion setup</span>
                <span className="stack-pill stay">Google Ads · Meta · GA4 (integrated)</span>
              </div>
              <div className="status-line">
                [ status ] Phase 1 attribution live now. CRM &amp; bookings cutover underway —
                137k contacts, 103k deals, 122k calls scoped for migration.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
